<template>
  <el-dialog :visible.sync="dialogFormVisible" :close-on-click-modal="false" :destroy-on-close="true" width="80%"
             top="15px" :title="addMode ? '添加资产类型' : '编辑资产类型'">
    <!-- 主体 -->
    <el-form label-position="left" ref="propertyTypeForm" :rules="propertyTypeFormRule" :model="propertyTypeForm"
             label-width="80px">
      <el-row :gutter="20">
        <!-- 左栏 -->
        <el-col :span="6">
          <el-form-item label="ID" prop="id">
            <el-input v-model="propertyTypeForm.id" disabled></el-input>
          </el-form-item>
          <el-form-item label="资产名" prop="name">
            <el-input v-model="propertyTypeForm.name"></el-input>
          </el-form-item>
          <el-form-item label="分配基数" prop="videoType">
            <el-select v-model="propertyTypeForm.videoType" placeholder="请选择文章类型">
              <el-option v-for="item in 5" :key="item.id" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 右栏 -->
        <el-col :span="18">
          <mavon-editor v-model="bufferContent" ref="md" :style="{height:'560px'}" @imgAdd="handleEditorImgAdd"/>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button type="warning">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "EditPropertyType",
  props: {
    addMode: Boolean,
  },
  data() {
    return {
      dialogFormVisible: false,
      propertyTypeForm: {
        id: '',
        name: '',
      },
      propertyTypeFormRule: {},
      bufferId: '',
      bufferContent: '',
    }
  },
}
</script>

<style scoped>

</style>